"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CacheType;
(function (CacheType) {
    CacheType["FINANCE"] = "finance";
    CacheType["DEAL"] = "deal";
    CacheType["DEALER"] = "dealer";
    CacheType["TRANSLATIONS"] = "translations";
    CacheType["USER"] = "user";
})(CacheType = exports.CacheType || (exports.CacheType = {}));
var DealKey;
(function (DealKey) {
    DealKey["CURRENT_DEAL"] = "currentDeal";
})(DealKey = exports.DealKey || (exports.DealKey = {}));
var UserKey;
(function (UserKey) {
    UserKey["IS_LOGGED"] = "isUserLogged";
    UserKey["USER_DETAILS"] = "userDetails";
    UserKey["USER_ADDRESS"] = "userAddress";
})(UserKey = exports.UserKey || (exports.UserKey = {}));
//# sourceMappingURL=model.js.map